import styled from 'styled-components';
import React, { useState, useEffect, useContext } from 'react';
import Row from 'components/Row';
import Page from 'components/Page';
import PricingCard from './PricingCard';
import { getPricingPlans, verifyKhaltiPayment } from '../firebase';
import { Title } from 'components/headerBanner/HeaderBanner';
import { SubTitle } from 'components/headerBanner/HeaderBanner';
import { PresentPage } from 'components/headerBanner/HeaderBanner';
import { BannerContainer } from 'components/headerBanner/HeaderBanner';
import CustomModal from 'components/Modal';
import { useModal } from 'components/Modal';
import { ModalCard } from 'components/Modal';
import { CircularProgress } from '@material-ui/core';
import KhaltiCheckout from 'khalti-web';
import { TopBarContext } from 'layouts/DashboardLayout';
import CloseIcon from 'mdi-react/CloseIcon';
import Col from 'components/Col';
import { khaltiConfiguration } from 'api/config';

function PricingPage() {
  const [plans, setPlans] = useState([]);
  const [verifying, setVerifying] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState();
  const [message, setMessage] = useState();

  const topBar = useContext(TopBarContext);

  const editModal = useModal();

  useEffect(() => {
    let unSubscribe = true;
    getPricingPlans().then(plans => {
      if (unSubscribe) {
        setPlans(plans);
      }
    });
    return () => (unSubscribe = false);
  }, []);

  const buyPlan = plan => {
    setSelectedPlan(plan);
    editModal.open();
  };

  const getCardContent = () => {
    const logo = {
      khaltiLogo:
        'https://www.nepalitrends.com/wp-content/uploads/2018/03/khalti.png',
      esewaLogo:
        'https://www.nepalitrends.com/wp-content/uploads/2018/03/esewa.png'
    };

    if (verifying) return <CircularProgress />;
    else if (message) return <div>{message}</div>;
    else
      return (
        <React.Fragment>
          <Row>
            <Col>
              <div>Pay Using</div>
              <PaymentLogo
                src={logo.khaltiLogo}
                onClick={() => payWithKhalti()}
              />
              {/* <Divider /> */}
              {/* <PaymentLogo src={logo.esewaLogo} onClick={payWithEsewa} /> */}
            </Col>
            <div style={{ cursor: 'pointer', borderRadius: '3px' }}>
              <CloseIcon
                onClick={() => {
                  editModal.close();
                }}
              />
            </div>
          </Row>
        </React.Fragment>
      );
  };

  const payWithKhalti = () => {
    editModal.close();
    let khaltiConfig = {
      publicKey: khaltiConfiguration.publicKey,
      productIdentity: selectedPlan.product_sku,
      productName: selectedPlan.name,
      productUrl: khaltiConfiguration.productURL,
      merchant_value: selectedPlan.exams,
      eventHandler: {
        async onSuccess(payload) {
          setVerifying(true);
          var resp = await verifyKhaltiPayment(payload, selectedPlan);
          setVerifying(false);
          setMessage(resp.message);
          if (resp.success) {
            showPaymentSuccededUI();
          } else {
            // TODO: User ko paisa katyo bhancha but topup bhayena follow up his issue.
            alert('Paisa katyo but topup bhayena');
          }
          setSelectedPlan(null);
        },
        onError() {
          setSelectedPlan(null);
        },
        onClose() {
          console.log('widget is closing');
        }
      }
    };
    let checkout = new KhaltiCheckout(khaltiConfig);
    checkout.show({ amount: selectedPlan.price_khalti });
  };

  const showPaymentSuccededUI = () => {
    topBar.show('success', 'Your payment is succeded', '', true, true);
  };

  // const payWithEsewa = () => {
  //   editModal.close();
  //   console.log('Esewa');
  // };

  return (
    <React.Fragment>
      <BannerContainer>
        <PresentPage>
          <Title color={'white'}>Pricing</Title>
          <SubTitle>Get Tokens to appear in an exam</SubTitle>
        </PresentPage>
      </BannerContainer>
      <StyledPage>
        <div>
          <Row justify="center">
            <Title color="black">Choose a package for continuous exams</Title>
          </Row>
          <Row justify="center">
            <SubTitle style={{ color: '#95999e' }}>
              Check out which option is right for you
            </SubTitle>
          </Row>
          <PricingContainer>
            {plans.map(plan => (
              <PricingCard
                plan={plan}
                key={plan.planKey}
                primary={plan.primary}
                onClick={() => {
                  buyPlan(plan);
                }}
              />
            ))}
            <CustomModal
              {...editModal.props}
              onClose={() => {
                setSelectedPlan(null);
                editModal.close();
              }}
            >
              <ModalCard>{getCardContent()}</ModalCard>
            </CustomModal>
          </PricingContainer>
        </div>
      </StyledPage>
    </React.Fragment>
  );
}

const StyledPage = styled(Page)`
  .loldiv {
    width: 75%;
    margin-left: 12%;
    margin-top: 50px;
  }
`;

const PricingContainer = styled(Row).attrs({
  justify: 'center',
  margintop: '50px'
})`
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
  }
`;

export default styled(PricingPage)`
  margin-top: 50px;
`;

export const PaymentLogo = styled.img`
  && {
    width: 100px;
    padding: 10px;
    cursor: pointer;
  }
`;
